<!-- eslint-disable -->
<script setup>
import { useFooterSectionStore } from '@/stores/footer_sections';
import { useInitializeStore } from '@/stores/initialize';
import moment from 'moment';
import { onMounted, computed } from 'vue';
import _ from 'lodash';
import { useDatesStore } from '@/stores/dates';

const footerSectionStore = useFooterSectionStore();
const initializeStore = useInitializeStore();
const datesStore = useDatesStore();

onMounted(() => {
	if (footerSectionStore.hasEmrSealInRegulation) {
		const emrItem = footerSectionStore.getEmrSealItem;
		const sealId = emrItem?.redirect_url;
		if (sealId && !document.querySelector('script[data-emr-seal]')) {
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = `https://${sealId}.seals-emr.certria.com/emr-seal.js`;
			script.setAttribute('data-emr-seal', 'true');
			script.onerror = () => {
				console.warn('[EMR Seal] Script failed to load. Check seal ID or Certria endpoint.', script.src);
			};
			document.head.appendChild(script);
		}
	}

	injectAnjSealScript();
});


function injectAnjSealScript() {
	if (!footerSectionStore.hasAnjSealInRegulation) return;
	const sealItem = footerSectionStore.getAnjSealItem;
	const sealId = sealItem?.redirect_url;
	if (!sealId) return;

	// Find existing seal script
	const existingScript = document.querySelector('script[data-anj-seal]');

	if (existingScript) {
		existingScript.remove();
	}

	const script = document.createElement('script');
	let src = process.env.VUE_APP_HAS_LOCAL_ANJ == 'true' ? process.env.VUE_APP_URL + '/anjan-seal.js' : `https://${sealId}.snippet.anjcdn.org/anj-seal.js`;
	script.src = src;
	script.setAttribute('data-anj-seal', 'true');
	if (process.env.VUE_APP_HAS_LOCAL_ANJ != 'true') {
		script.onload = () => {
			const fnName = `anj_${sealId.replace(/-/g, '_')}`;
			if (window[fnName]?.init) window[fnName].init();
		};
	}
	document.head.appendChild(script);
	setTimeout(() => {
		let anja_div = document.getElementById(`anj-${sealId}`);
		let firstDiv = anja_div.querySelector('div');

		if (firstDiv) {
			firstDiv.style.minWidth = '55px';
		}
	}, 1000);
}

const regulation_items = computed(() =>
	_.filter(footerSectionStore.getRegulationSection?.items,
		item => item.type !== 'emr_seal' && item.type !== 'anj_seal')
);

</script>
<template>
	<template v-if="footerSectionStore.getRegulationSection && footerSectionStore.getRegulationSection.items.length > 0">
		<div class="regulation-flex">
			<a v-for="item in regulation_items" :key="item.id" :href="item.redirect_url" target="_blank">
				<img :src="item.media_url" alt="Regulation Icon" width="60" />
			</a>
			<div v-if="footerSectionStore.hasEmrSealInRegulation"
				:id="`emr-${footerSectionStore.getEmrSealItem?.redirect_url}`"
				:data-emr-seal-id="footerSectionStore.getEmrSealItem?.redirect_url"
				data-emr-image-size="60"
				data-emr-image-type="basic-light-large"></div>
			<div v-if="footerSectionStore.hasAnjSealInRegulation"
				:id="`anj-${footerSectionStore.getAnjSealItem?.redirect_url}`"
				:data-anj-seal-id="footerSectionStore.getAnjSealItem?.redirect_url"
				data-anj-image-size="60"
				data-anj-image-type="basic-small">
			</div>

			<span id="browser-time" class="browser-time">
				{{ datesStore.translateAndOffsetDatetime(moment.unix(initializeStore.server_timestamp).utc()).format('hh:mm:ss A') }}
			</span>
		</div>
	</template>
</template>

<style scoped>
.regulation-flex {
	display: flex;
	gap: 10px;
	/* max-width: 50%; */
	align-items: center;
	flex-wrap: wrap;
}

.browser-time {
	width: 150px;
	background-color: gray;
	color: var(--white);
	padding: 5px 10px;
	border-radius: 5px;
	/* font-weight: bold; */
	display: inline-block;
	height:100%;
	font-variant-numeric: tabular-nums;
	text-align: center;
}
html[dir="rtl"] .browser-time {
	width: 200px;
}
@media screen and (max-width: 767px) {
	.browser-time {
		display: none;
	}
}
</style>
